import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Language } from '@/types';
import i18n from '@/i18n';

interface I18nState {
  language: Language;
  dir: 'rtl' | 'ltr';
}

const initialState: I18nState = {
  language: (localStorage.getItem('language') as Language) || 'ar',
  dir: ['ar', 'ku'].includes(localStorage.getItem('language') || 'ar') ? 'rtl' : 'ltr',
};

const i18nSlice = createSlice({
  name: 'i18n',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<Language>) => {
      state.language = action.payload;
      state.dir = ['ar', 'ku'].includes(action.payload) ? 'rtl' : 'ltr';
      localStorage.setItem('language', action.payload);
      i18n.changeLanguage(action.payload);
      document.documentElement.dir = state.dir;
      document.documentElement.lang = action.payload;
    },
  },
});

export const { setLanguage } = i18nSlice.actions;
export default i18nSlice.reducer;







